import React, { useEffect, useState } from "react";
import Link from "next/link";
import { useDisclosure } from "@mantine/hooks";
import GetQuoteModal from "@components/Modal/GetQuoteModal";

function DiscountAlertBanner({ content }) {
  const [domainUrl, setDomainUrl] = useState("https://appform.nivabupa.com");

  // const [opened, { open, close }] = useDisclosure(false);

  // const quoteModalHandler = (e) => {
  //   e.preventDefault();
  //   open();
  // }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hostname = window?.location?.hostname;
      const url =
        hostname === "localhost" || hostname === "127.0.0.1"
          ? "https://appform.nivabupa.com"
          : window?.location?.origin;
      setDomainUrl(url);
    }
  }, []);

  return (
    <div className="mx-auto max-w-[1280px] w-full">
      <div className="hidden md:block mb-8">
        {/* <Link target="_blank" href={content?.url || "/"}> */}
        <div>
          <img
            src={`${domainUrl}${content?.banner_image?.data?.attributes?.url}`}
            alt="Discount alert"
            loading="lazy"
            className="w-full"
          />
        </div>
        {/* </Link> */}
      </div>
      <div className="block md:hidden mb-8">
        {/* <Link target="_blank" href={content?.url || "/"}> */}
        <div>
          <img
            src={`${domainUrl}${content?.banner_mobile_image?.data?.[0]?.attributes?.url}`}
            alt="Discount alert"
            loading="lazy"
            className="w-full"
          />
        </div>
        {/* </Link> */}
      </div>
      {/* <GetQuoteModal opened={opened} close={close} open={open} isds={isds}/> */}
    </div>
  );
}

export default DiscountAlertBanner;
